import React from 'react';
import { Box } from '@hover/blueprint';
import { PRICING_BASIC_TOOLTIPS } from '../../../../constants';
import PricingTooltipsList from '../PricingTooltipsList';
import BasicsFooter from './BasicsFooter';

const BasicsFeaturesTabletAndDesktop: React.FC = () => (
  <Box d={{ base: 'none', tablet: 'flex' }} flexDir="column">
    <PricingTooltipsList data={PRICING_BASIC_TOOLTIPS} />
    <BasicsFooter />
  </Box>
);

export default BasicsFeaturesTabletAndDesktop;
